import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Sparkles, Wand2 } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export const InvestigationCTA = ({ query, defaultCategory = "politica" }) => {
        const [busy, setBusy] = useState(false);
        const [category, setCategory] = useState(defaultCategory);
        const [suggested, setSuggested] = useState(false);

        const run = async () => {
                if (!query || query.trim().length < 3) {
                        toast.error("Termo demasiado curto.");
                        return;
                }
                setBusy(true);
                try {
                        const r = await api.post("/topics/suggest", {
                                query: query.trim(),
                                category,
                        });
                        if (r.data.status === "exists") {
                                window.location.href = `/topico/${r.data.slug}`;
                        } else {
                                setSuggested(true);
                        }
                } catch (e) {
                        toast.error(
                                e.response?.data?.detail ||
                                        "Erro ao enviar sugestão. Tenta novamente."
                        );
                } finally {
                        setBusy(false);
                }
        };

        if (suggested) {
                return (
                        <div
                                data-testid="investigation-cta"
                                className="relative border border-[var(--controversy)] bg-[var(--paper)] p-10 md:p-14 max-w-3xl mx-auto mt-4"
                        >
                                <div className="absolute inset-0 crosshair-bg opacity-30 pointer-events-none" />
                                <div className="absolute -top-3 left-8 stamp stamp-gold pulse-class">
                                        Sugestão Registada
                                </div>
                                <div className="relative text-center">
                                        <Sparkles className="mx-auto text-[var(--controversy)] mb-4" size={32} strokeWidth={1.5} />
                                        <h3 className="font-serif text-2xl md:text-3xl leading-tight text-[var(--ink)] mb-4">
                                                Tema enviado para a nossa equipa.
                                        </h3>
                                        <p className="text-sm leading-relaxed text-[var(--ink-soft)] font-mono">
                                                A investigação ficará publicamente disponível no arquivo caso a nossa equipa considere os indícios relevantes após análise preliminar.
                                        </p>
                                </div>
                        </div>
                );
        }

        return (
                <div
                        data-testid="investigation-cta"
                        className="relative border border-[var(--line-strong)] bg-[var(--paper)] p-10 md:p-14 max-w-3xl mx-auto mt-4"
                >
                        <div className="absolute inset-0 crosshair-bg opacity-30 pointer-events-none" />
                        <div className="absolute -top-3 left-8 stamp stamp-gold pulse-class">
                                Sem registo · sugestão aberta
                        </div>
                        <div className="relative">
                                <div className="overline text-[var(--ink-faint)] mb-3 flex items-center gap-2">
                                        <Wand2 size={12} strokeWidth={1.5} /> Pesquisa não tem dossiê
                                </div>
                                <h3 className="font-serif text-3xl md:text-4xl leading-tight text-[var(--ink)]">
                                        Quer sugerir a abertura de um dossiê sobre
                                        <br />
                                        <span className="italic text-[var(--controversy)] break-words">
                                                &ldquo;{query}&rdquo;
                                        </span>
                                        ?
                                </h3>
                                <p className="text-sm leading-relaxed text-[var(--ink-soft)] mt-5 font-mono">
                                        A nossa equipa de investigadores será notificada para cruzar dados, 
                                        expor narrativas mediáticas e documentar a verdade com fontes reais. 
                                        O dossiê ficará publicamente disponível no arquivo.
                                </p>

                                <div className="mt-6 flex items-center gap-2 flex-wrap">
                                        <span className="overline text-[var(--ink-faint)]">
                                                Categoria:
                                        </span>
                                        {[
                                                ["politica", "Política"],
                                                ["media", "Media"],
                                                ["justica", "Justiça"],
                                                ["economico", "Económico"],
                                                ["social", "Social"],
                                                ["historico", "Histórico"],
                                                ["ciencia_saude", "Ciência e Saúde"],
                                                ["religiao", "Religião"],
                                                ["esoterismo", "Esoterismo"],
                                        ].map(([k, l]) => (
                                                <button
                                                        key={k}
                                                        onClick={() => setCategory(k)}
                                                        data-testid={`investigate-cat-${k}`}
                                                        className="overline px-2 py-1 border transition-colors"
                                                        style={{
                                                                borderColor:
                                                                        category === k
                                                                                ? "var(--controversy)"
                                                                                : "var(--line-strong)",
                                                                color:
                                                                        category === k
                                                                                ? "var(--controversy)"
                                                                                : "var(--ink-soft)",
                                                        }}
                                                >
                                                        {l}
                                                </button>
                                        ))}
                                </div>

                                <button
                                        data-testid="investigate-now-btn"
                                        onClick={run}
                                        disabled={busy}
                                        className="mt-8 overline px-6 py-3 bg-[var(--controversy)] text-[var(--bg-deep)] inline-flex items-center gap-2 hover:bg-[var(--ink)] transition-colors disabled:opacity-50"
                                >
                                        {busy ? (
                                                <>
                                                        <Loader2
                                                                size={14}
                                                                strokeWidth={1.5}
                                                                className="animate-spin"
                                                        />
                                                        A enviar sugestão...
                                                </>
                                        ) : (
                                                <>
                                                        <Sparkles size={14} strokeWidth={2} /> Sugerir Investigação →
                                                </>
                                        )}
                                </button>
                                <p className="overline text-[var(--ink-faint)] mt-4">
                                        Todas as sugestões são alvo de triagem editorial
                                </p>
                        </div>
                </div>
        );
};

export default InvestigationCTA;
